import CookieHelper from 'src/DistributionPackages/Avaloq.NodeTypes/Resources/Private/JavaScript/Modules/CookieHelper'

export default class LanguageNavigation {
    constructor() {
        this.toggle = document.querySelector('.js_language-navigation__toggle')
        this.dropdown = document.querySelector('.js_language-navigation__dropdown')
        this.toggle.addEventListener('click', () => this.toggleVisibility())
        this.toggle.addEventListener('keydown', (event) => {
            if (event.key === 'ArrowDown') {
                event.preventDefault()
                this.showDropdown()
            }
        })
        this.dropdown.addEventListener('focusout', (event) => {
            if (!this.dropdown.contains(event.relatedTarget)) {
                this.hideDropdown()
            }
        })

        this.dropdown.addEventListener('mouseleave', (event) => {
            if (!this.dropdown.contains(event.relatedTarget)) {
                this.hideDropdown()
            }
        })

        // initial enabling of the language selector
        if (!this.isLanguageAlreadySelectedByUser()) {
            this.languageLinks = document.querySelectorAll('.js_language-navigation__dropdown a')
            this.languageLinks.forEach((link) => {
                link.addEventListener('click', () => {
                    CookieHelper.setCookie('isLanguageSelectedByUser', 'true', 30)
                })
            })
        }

        // check for click outside the dropdown to close the dropdown
        window.addEventListener('click', (event) => {
            if (!event.target.closest('.meta-nav__list-item--language')) {
                this.hideDropdown()
            }
        })
    }

    toggleVisibility() {
        const isHidden = this.dropdown.style.display === 'none' || this.dropdown.style.display === ''
        if (isHidden) {
            this.showDropdown()
        } else {
            this.hideDropdown()
        }
    }

    showDropdown() {
        this.dropdown.style.display = 'flex'
        this.toggle.setAttribute('aria-expanded', 'true')

        // FIX: Focus the first link in the dropdown for better keyboard accessibility.
        const firstLink = this.dropdown.firstElementChild
        if (firstLink) {
            firstLink.focus()
        }
    }

    hideDropdown() {
        // CLARITY: Check if it's already hidden to avoid redundant DOM manipulation.
        if (this.dropdown.style.display === 'none') return

        this.dropdown.style.display = 'none'
        this.toggle.setAttribute('aria-expanded', 'false')
    }

    isLanguageAlreadySelectedByUser() {
        return CookieHelper.getCookie('isLanguageSelectedByUser') === 'true'
    }
}
